import { styled } from '@mui/material';

export const DropWrapper = styled('div')(() => ({
    position: 'relative',

    '.delete': {
        position: 'absolute',
        top: 0,
        right: 0,
        padding: '0.25rem 0.25rem 0.5rem 0.5rem',
    },

    '&.disabled': {
        '.dropzone': {
            cursor: 'auto',
        },

        '.title': {
            color: '#a5abb2',
        },
    },
}));

export const DropZone = styled('div')(({theme}) => ({
    border: '2px #6c757d dashed',
    marginBottom: '1rem',
    padding: '0.5rem',
    textAlign: 'center',
    cursor: 'pointer',

    '&.invalid': {
        borderColor: theme.palette.warning,

        '.title': {
            color: theme.palette.warning,
        }
    },

    '&.drop-image': {
        '.title': {
            color: '#6c757d',
            fontWeight: 'bold',

            'svg': {
                width: '6rem',
                height: '6rem',
            },

            'img': {
                maxWidth: '100%',
                height: '6rem',
            },

            '&.compact': {
                'svg': {
                    width: '2rem',
                    height: '2rem',
                },
            },
        },

        '.drop-here': {
            padding: '2.5rem 0.5rem',
            backgroundColor: '#ebebeb',
            height: 'calc(100% - 1rem)',
            width: 'calc(100% - 1rem)',
            position: 'absolute',
            top: '.5rem',
        },
    },


}));

export const UnderTextUploadButton = styled('div')(({theme}) => ({
    backgroundColor: theme.palette.grey['100'],
    borderStyle: 'solid',
    borderWidth: '0 1px 1px',
    borderColor: theme.palette.grey['200'],
    cursor: 'pointer',
    borderRadius: '0 0 4px 4px',
    padding: 4,
    marginTop: -4,

    '&:hover': {
        backgroundColor: theme.palette.grey['200'],
        borderColor: theme.palette.grey['300'],
    },
}));
